import { SortType } from "../types/SortType";



const ReOrderItem = (arr:any[],fromIndex: number,toIndex: number) => {
    var item = arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, item[0]);
    return arr;
}

const compareBy = (key: any) => {
    return function (a: any, b: any) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
}

const sortData = (dataSource:any[],sortType:SortType,sortFielName:string) =>{
    dataSource.sort(compareBy(sortFielName));
    if (sortType === SortType.down) {
      dataSource.reverse(); //for descending
    }
    return dataSource;
}

export {sortData,ReOrderItem}